import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import routes from './routes';


// Global navigate function
let navigateGlobal = null;

export const navigateTo = (route) => {
  if (navigateGlobal) {
    navigateGlobal(route); // Use global navigate instance
  } else {
    console.error("Navigation function is not initialized!");
  }
};
const GlobalButton = ({ label, routeName, className, type = 'button', onClick }) => {
  const navigate = useNavigate();
  

  // Initialize global navigate function
  React.useEffect(() => {
    if (!navigateGlobal) {
      navigateGlobal = navigate;
    }
  }, [navigate]);

  // Route Navigation
  const handleNavigation = () => {
    const route = routes[routeName];
    if (route) {
      navigate(route);
    }
    if (onClick) {
      onClick(); // Additional custom logic
    }
  };

  return (
    <button
      type={type}
      className={` ${className}`}
      onClick={handleNavigation}
    >
      {label}
    </button>
  );
};

GlobalButton.propTypes = {
  label: PropTypes.string.isRequired, // Button label text
  routeName: PropTypes.string, // Route name from `routes.js`
  className: PropTypes.string, // Optional custom styles
  type: PropTypes.string, // Button type (default: 'button')
  onClick: PropTypes.func, // Optional custom click handler
};

export default GlobalButton;
